var map = {
	"./backoffice.de.locale.json": 4625,
	"./backoffice.el.locale.json": 9355,
	"./backoffice.en.locale.json": 9657,
	"./backoffice.es.locale.json": 2124,
	"./backoffice.fr.locale.json": 1424,
	"./backoffice.it.locale.json": 1847,
	"./backoffice.ru.locale.json": 6683,
	"./backoffice.zh.locale.json": 6326,
	"./base.de.locale.json": 6619,
	"./base.el.locale.json": 7837,
	"./base.en.locale.json": 8591,
	"./base.es.locale.json": 6250,
	"./base.fr.locale.json": 6162,
	"./base.it.locale.json": 4097,
	"./base.ru.locale.json": 3025,
	"./base.zh.locale.json": 7820,
	"./customerAnalytics.de.locale.json": 5180,
	"./customerAnalytics.el.locale.json": 4346,
	"./customerAnalytics.en.locale.json": 2152,
	"./customerAnalytics.es.locale.json": 4317,
	"./customerAnalytics.fr.locale.json": 6969,
	"./customerAnalytics.it.locale.json": 5982,
	"./customerAnalytics.ru.locale.json": 6026,
	"./customerAnalytics.zh.locale.json": 1879,
	"./giftSelection.de.locale.json": 5048,
	"./giftSelection.el.locale.json": 4950,
	"./giftSelection.en.locale.json": 9140,
	"./giftSelection.es.locale.json": 9169,
	"./giftSelection.fr.locale.json": 7645,
	"./giftSelection.it.locale.json": 8658,
	"./giftSelection.ru.locale.json": 9310,
	"./giftSelection.zh.locale.json": 1219,
	"./services.de.locale.json": 902,
	"./services.el.locale.json": 2876,
	"./services.en.locale.json": 2446,
	"./services.es.locale.json": 443,
	"./services.fr.locale.json": 3939,
	"./services.it.locale.json": 7296,
	"./services.ru.locale.json": 2800,
	"./services.zh.locale.json": 7965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4572;